import classNames from 'classnames';
import React from 'react';

import { BreadcrumbsStyle } from '../../Common/Layout/BreadcrumbsStyle.csharp';

export interface Breadcrumb {
    text: string;
    href: string;
    hideOnMobile?: boolean;
    onClick?: () => void;
}
interface BreadcrumbsProps {
    breadcrumbs: Breadcrumb[];
    style: BreadcrumbsStyle;
}

export const Breadcrumbs = (props: BreadcrumbsProps) => {
    function onBreadcrumbClick(e: React.MouseEvent<HTMLAnchorElement>, breadcrumb: Breadcrumb) {
        if (breadcrumb.onClick) {
            breadcrumb.onClick();
            e.preventDefault();
        }
    }

    return (
        <>
            {props.breadcrumbs.length > 0 && (
                <div
                    className={classNames('Breadcrumbs', { hideOnMobile: props.style === BreadcrumbsStyle.HideOnMobile })}
                    role="navigation"
                    aria-label="breadcrumbs"
                >
                    <div className="Breadcrumbs__Wrapper">
                        <ul className="Breadcrumbs__Inner" itemScope itemType="https://schema.org/BreadcrumbList">
                            {props.breadcrumbs.map((breadcrumb: Breadcrumb, index: number) => (
                                <li
                                    key={breadcrumb.text}
                                    itemProp="itemListElement"
                                    itemScope
                                    itemType="http://schema.org/ListItem"
                                    className={classNames(breadcrumb.hideOnMobile && 'hideOnMobile')}
                                >
                                    <a href={breadcrumb.href} itemProp="item" onClick={(e) => onBreadcrumbClick(e, breadcrumb)}>
                                        <span itemProp="name">{breadcrumb.text}</span>
                                    </a>
                                    <meta itemProp="position" content={(index + 1).toString()} />
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            )}
        </>
    );
};
